<template lang="pug">
.d-flex.justify-content-center.align-items-center(v-if="loading")
  | ...

.d-flex.flex-column.align-items-center(v-else-if="error")
  .d-flex.align-items-center.text-lighter.mb-10(:title="error")
    i.hi.hi-14.hi-warning.mr-10
    | Can't load member info
  a.d-flex.align-items-center(
    href="#"
    @click.stop.prevent="hydrate"
  )
    i.hi.hi-14.hi-refresh.mr-10
    b Try again

.p-16(v-else)
  .d-flex.break-word.mb-15
    .mt-5
      .user-status.user-status--speck.mr-10(:class="{ 'is-online': membership.is_online }")
        AppAvatar(:avatar="user.avatar.normal")
    div
      h4.m-0 {{ user.name }}
      small.text-lighter
        | Joined {{ membership.created_on }}

  .d-flex.mb-15.align-items-center(v-if="membership.job_title")
    i.hi.hi-16.hi-briefcase.text-lighter.mr-10
    .ellipsis {{ membership.job_title }}

  .d-flex.mb-15.align-items-center(v-if="user.email")
    i.hi.hi-16.hi-mail.text-lighter.mr-10
    .ellipsis {{ user.email }}

  .d-flex.mb-15.align-items-center(v-if="formattedTimeZone")
    i.hi.hi-16.hi-globe.text-lighter.mr-10
    .ellipsis {{ formattedTimeZone }}

  .d-flex.mt-30.justify-content-between
    a.text-lighter.strong(
      :href="memberProfileLink"
      :target="target"
    )
      | Member profile
    a.text-lighter(
      v-tooltip="{ placement: 'top', closeOnClick: true }"
      :href="organizationUserActivitiesLink"
      title="View activity"
    )
      i.hi.hi-16.hi-activity
</template>

<script>
import { PopoverAvatarUserCardResource } from '~/resources';
import AppAvatar from '~/components/AppAvatar.vue';

export default {
  name: 'PopoverAvatarUserCard',
  components: { AppAvatar },
  props: {
    userId: {
      type: Number,
      required: true,
    },
    organizationId: {
      type: Number,
      required: true,
    },
    tab: {
      type: String,
      default: null,
    },
    target: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      membership: {},
    };
  },
  computed: {
    memberProfileLink() {
      return PopoverAvatarUserCardResource.memberProfileLink({
        userId: this.userId,
        organizationId: this.organizationId,
        tab: this.tab,
      });
    },
    organizationUserActivitiesLink() {
      return PopoverAvatarUserCardResource.organizationUserActivitiesLink({
        organizationId: this.organizationId,
        userId: this.userId,
      });
    },
    formattedTimeZone() {
      return this.user.time_zone.formatted_timezone;
    },
    user() {
      return this.membership.user || {};
    },
    usersAvatars() {
      return new Map([[this.user.id, this.user.avatar]]);
    },
  },
  mounted() {
    this.hydrate();
  },
  methods: {
    hydrate() {
      this.reset();
      this.load();
      this.updatePosition();
    },
    reset() {
      this.loading = true;
      this.error = false;
    },
    updatePosition() {
      window.dispatchEvent(new Event('resize'));
    },
    load() {
      PopoverAvatarUserCardResource.get({ userId: this.userId, organizationId: this.organizationId })
        .then(({ membership }) => {
          this.membership = membership;
          this.loading = false;
        })
        .catch(({ error }) => {
          this.error = error;
          this.loading = false;
        })
        .finally(this.updatePosition);
    },
    hidePopover() {
      this.$emit('close-popover');
    },
  },
};
</script>
